import { render, staticRenderFns } from "./ElderlyOrder.vue?vue&type=template&id=03741405&scoped=true&"
import script from "./ElderlyOrder.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03741405",
  null
  
)

export default component.exports